module.exports = __webpack_public_path__ + "components/flag/static/square/sz-d78ee80cb91e6ad0c7408ea6f27700aa.svg";